'use strict';

export default class Sidebar {
  /**
    * @param {String} name - name of sidebar
    * @param {DOMElement} elem - selector sidebar DOMElement
    * @param {DOMElement} toggler - selector toggler btn DOMElement
    * @param {Boolean} storage - bool to save state in localestorage
    */
  constructor(params) {
    this.name = params.name
    this.elem = params.elem
    this.togglerElem = params.toggler
    this.storage = params.storage || false
    this.sidebarClose = true

    this.init()
  }

  init () {
    // check if position already saved in localStorage
    if(this.storage) {
      if (localStorage.getItem(this.name + '-position') == 'collapse') {
        this.closeSidebar()
       }  else if (localStorage.getItem(this.name + '-position') == 'expand') {
         this.openSidebar()
       }
    }

    // attach toggle event
    this.togglerElem.addEventListener('click', (e) => {
      this.toggleCollapse()
    })
  }

  /**
    * @desc Toggle sidebar
    * @return {boolean} sidebar state
    */
  toggleCollapse () {
    if(this.sidebarOpen) {
      this.closeSidebar()
    } else {
      this.openSidebar()
    }

    return this.sidebarOpen
  }

  /**
   * @desc Open sidebar
   * @return {boolean} sidebar state
   */
  openSidebar () {
    this.sidebarOpen = true
    // remove body class
    document.body.classList.remove(this.name + '-collapse')
    // remove sidebar class
    this.elem.classList.remove('sidebar-collapse')
    // add btn toggler class
    this.togglerElem.classList.add('reverse');

    this.savingState()
  }

  /**
   * @desc Close sidebar
   * @return {boolean} sidebar state
   */
  closeSidebar () {
    this.sidebarOpen = false
    // add body class
    document.body.classList.add(this.name + '-collapse')
    // add sidebar class
    this.elem.classList.add('sidebar-collapse')
    // remove btn toggler class
    this.togglerElem.classList.remove('reverse');

    this.savingState()
  }

  /**
   * @desc Saving sidebar state in localStorage
   */
  savingState () {
    // save position in localStorage
    if(this.storage) {
      let value = this.sidebarOpen ? 'expand' : 'collapse'

      localStorage.setItem(this.name + '-position', value);
    }
  }
}



